import { create } from "zustand";
import { persist } from "zustand/middleware";

const useIntercomStore = create(
  persist(
    (set, get) => ({
      // Admin state
      currentAdmin: null,
      adminsList: [],
      isLoading: false,
      error: null,

      // Actions
      setCurrentAdmin: (admin) => {
        set({ currentAdmin: admin, error: null });
      },

      setAdminsList: (admins) => {
        set({ adminsList: admins });

        // Auto-select first admin if no current admin is set
        const { currentAdmin } = get();
        if (!currentAdmin && admins.length > 0) {
          set({ currentAdmin: admins[0] });
        }
      },

      setLoading: (isLoading) => {
        set({ isLoading });
      },

      setError: (error) => {
        set({ error });
      },

      // Helper to get current admin ID for API calls
      getCurrentAdminId: () => {
        const { currentAdmin } = get();
        return currentAdmin?.id || null;
      },

      // Clear admin data (for logout)
      clearAdminData: () => {
        set({
          currentAdmin: null,
          adminsList: [],
          error: null,
        });
      },
    }),
    {
      name: "admin-storage", // localStorage key
      partialize: (state) => ({
        currentAdmin: state.currentAdmin,
        adminsList: state.adminsList,
      }),
    }
  )
);

export default useIntercomStore;
